import React, { useState } from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./NewPaymentElementForm";
import GraphQLErrors from "../../shared/GraphQLErrors";
import {cancelAddCreditCard} from "../../actions/AccountActions";
import {Map} from "immutable";
import LoadingLine from "../../shared/components/forms/LoadingLine";
import { useTranslation } from "react-i18next";
import { StripeElements } from "../views/Checkout/StripeElements";

function validateForm(_values) {
  let errors = Map();
  return errors.toJS();
}

function AddCreditCardFormContainer(props) {
  const { t } = useTranslation("common");

  const [errors, setErrors] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  function handleSubmit(paymentMethodId) {
    let values = {accountId: props.accountId, paymentMethodId: paymentMethodId};
    setSubmitting(true);

    props.customerAddPaymentMethod(values)
      .then((response) => {
        if (response.data.customerAddPaymentMethod.errors.length <= 0) {
          props.cancelAddCreditCard();
        } else {
          let better_errors = {_error: t("credit_card.add_failure")}
          setErrors(better_errors);
        }
      })
      .catch((_err) => {
        let better_errors = {_error: t("credit_card.add_failure")}
        setErrors(better_errors);
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  function handleCancel() {
    props.cancelAddCreditCard();
  }

  const { data } = props;
  if (data.loading) return <LoadingLine />
  if (data.error) return <GraphQLErrors error={data.error} />

  // StripeElements share the same clientSecret and it should be immutable..
  const clientSecret = data?.customerBillingSetupPaymentCredentials?.clientSecret;

  return (
    <StripeElements useLoadingLine={true}
      shopId={data.customerBillingShop.id}
      clientSecret={clientSecret}>
      <Form
        clientSecret={clientSecret}
        shopName={data.customerBillingShop.name}          
        submitting={submitting}
        errors={errors}
        validate={validateForm}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        />
    </StripeElements>
  );
}

const ADD_CREDIT_CARD = gql`
  mutation customerAddPaymentMethod($data: PaymentMethodIdInput!) {
    customerAddPaymentMethod(input: $data) {
      errors { key message }
    }
  }
`;

const QUERY = gql`
  query customerBillingShop($accountId: ID!) {
    customerBillingShop(accountId: $accountId) {
      id
      name
    }
    customerBillingSetupPaymentCredentials(accountId: $accountId) {
      clientSecret
    }
  }
`


const withQueries = compose(
  graphql(QUERY, {
    options: (props) => ({
      variables: {
        accountId: props.accountId
      },
      fetchPolicy: "network-only"
    })
  }),
  graphql(ADD_CREDIT_CARD, {
    props: ({ mutate }) => ({
      customerAddPaymentMethod: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelAddCreditCard})(withQueries(AddCreditCardFormContainer));

